import React from "react";

const CallUsModal = ({ setIsCallOpen }) => {
  const closeCallModal = () => {
    setIsCallOpen(false);
  };
  return (
    <div className="callus-card">
      <div className="callus-image">
        <img
          src="https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_250/v1643287735/AquaHeat/Navbar%20Images/callus_kp4lqr.webp"
          alt=""
        />
      </div>
      <div className="callus-text">
        <h2 className="callus-heading">Speak To An Advisor</h2>
        <p className="callus-p ">
          Have some questions about which boiler to choose? Are helpful advisors
          are available between 8:30am and 8pm
        </p>
        <h3 className="callus-num">Call Us On 0113 467 0278</h3>
        <button className="save-quote_btn" onClick={closeCallModal}>
          Close
        </button>
      </div>
    </div>
  );
};

export default CallUsModal;
